import { Grid, styled } from '@mui/material';
import { ICandidateFieldMapping, IMappingFormSetting } from 'wisestep-api';
import { Label, WsButton } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';

export interface IGridfieldItem {
  fieldItem: ICandidateFieldMapping;
  fieldKey: string;
  onRowChange(row: IMappingFormSetting, key: string): void;
}

const StyledLabel = styled(Label)(() => ({
  fontWeight: 'bold',
  width: '14vw',
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: '2vw',
}));

const GridfieldItem = ({ fieldItem, onRowChange, fieldKey }: IGridfieldItem) => {
  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_MAPPING_FIELDS_CUSTOMISATION,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];
  const disabledFields = ['name', 'email'];
  const actionAndResultsMandatory = ['recruiterActivity'];

  const togglePropValue = (row: IMappingFormSetting, prop: string, value: boolean) => {
    const newRow = row[prop] !== value ? { ...row, [prop]: value } : row;
    onRowChange(newRow, fieldKey);
    return newRow;
  };

  const togglePropValueForShowAndHide = (
    row: IMappingFormSetting,
    prop1: string,
    prop2: string,
    value: boolean
  ) => {
    const newRow = row[prop1] !== value ? { ...row, [prop1]: value, [prop2]: !value } : row;
    onRowChange(newRow, fieldKey);
    return newRow;
  };

  return (
    <Grid item display="flex" justifyContent={'space-between'}>
      <>
        <StyledLabel>{fieldItem?.fieldName}</StyledLabel>
        <WsButton
          variant={fieldItem?.mandatory ? 'contained' : 'outlined'}
          disabled={!manageAccess || disabledFields.includes(fieldKey)}
          onClick={() => togglePropValue(fieldItem, 'mandatory', true)}
        >
          Mandatory
        </WsButton>
        <WsButton
          variant={fieldItem?.mandatory ? 'outlined' : 'contained'}
          disabled={!manageAccess || disabledFields.includes(fieldKey)}
          onClick={() => togglePropValue(fieldItem, 'mandatory', false)}
        >
          Non-Mandatory
        </WsButton>
        <WsButton
          variant={fieldItem?.show ? 'contained' : 'outlined'}
          disabled={
            !manageAccess || fieldItem.mandatory || actionAndResultsMandatory.includes(fieldKey)
          }
          onClick={() => togglePropValueForShowAndHide(fieldItem, 'show', 'hidden', true)}
        >
          Show
        </WsButton>
        <WsButton
          variant={fieldItem?.show ? 'outlined' : 'contained'}
          disabled={
            !manageAccess || fieldItem.mandatory || actionAndResultsMandatory.includes(fieldKey)
          }
          onClick={() => togglePropValueForShowAndHide(fieldItem, 'hidden', 'show', true)}
        >
          Hide
        </WsButton>
      </>
    </Grid>
  );
};

export default GridfieldItem;
